import React from 'react';
import Cookies from 'universal-cookie';
// import correggiTest from '../services/correggiTest';
// import getDomande from '../services/getDomande';
import AudioSceltaMultipla from '../../components/Exam/AudioSceltaMultipla';
import AudioVeroFalso from '../../components/Exam/AudioVeroFalso';
import Cloze from '../../components/Exam/Cloze';
import Completamento from '../../components/Exam/Completamento';
import ConsegnaTest from '../../components/Exam/ConsegnaTest';
import RiorganizzazioneConcettuale from '../../components/Exam/RiorganizzazioneConcettuale';
import SceltaMultipla from '../../components/Exam/SceltaMultipla';
import TestoImmagine from '../../components/Exam/TestoImmagine';
import TestoTesto from '../../components/Exam/TestoTesto';
import VeroFalso from '../../components/Exam/VeroFalso';
import correggiTest from '../../services/correggiTest';
import setupTest from '../../services/setupTest';
import translateString from "../../utils/Locales";
import { Prompt } from 'react-router';

let t = translateString;
const cookies = new Cookies();
var countDown = 0;

const qs = require('querystring');

export default class Exam extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true, 
            domande: [],
            refs: [],
            timer: '',
            inConsegna: false,
            correctionDone: false,
            doingTest: true
        };
    }

    async componentDidMount() {
        let username = cookies.get('username');
        let token = cookies.get('token');
        const parsed = qs.parse(window.location.hash);
        let id = parsed['#/app/test?id']
        let test = await setupTest(username, token, id);
        if (test.result === 'KO') {
            this.setState({doingTest: false})
            let dbPath = cookies.get('db_path', { path: '/' });
            window.location.href = '/' + dbPath + "/#/app/editCorso"
            return
        }
        let durata = test.durata;
        let chunks = durata.split(":");
        var d = 0;
        d += parseInt(chunks[0]) * 3600;
        d += parseInt(chunks[1]) * 60;
        d += parseInt(chunks[2]);
        countDown = d * 1000;
        var refs = [];
        test.domande.forEach(() => {
            refs.push(React.createRef());
        });

        this.setState({ isLoading: false, domande: test.domande, refs, id });
        this.startTimer();
    }

    componentWillUnmount() {
        clearInterval(this.countDownInterval);
    }

    async startTimer() {

        this.countDownInterval = setInterval(() => {
            
            if (countDown <= 0) this.endTest();

            var minutes = Math.floor(countDown / 60000);
            var seconds = ((countDown % 60000) / 1000).toFixed(0);
            
            countDown -= 1000;
            this.showTimer(minutes + ":" + (seconds < 10 ? '0' : '') + seconds);
        }, 1000);
    }

    async endTest() {

        this.setState({ inConsegna: true });
        clearInterval(this.countDownInterval);

        var risposte = [];

        this.state.refs.forEach((r, ind) => {
            let tipo = this.state.domande[ind].tipo;
            let id = this.state.domande[ind].id;
            let risp = r.current.getRisposta();

            var risposta = {
                tipo: tipo,
                id: id,
                risposta: null
            };

            if (risp !== null) {
                if (!['2', '3', '6', '7'].includes(tipo)) {
                    risposta.risposta = risp;
                } else {
                    risposta.risposta = JSON.stringify(risp);
                }
            }

            risposte.push(risposta);
        });

        let username = cookies.get('username');
        let token = cookies.get('token');
        let res = await correggiTest(username, token, this.state.id, countDown / 1000, JSON.stringify(risposte));
        if (res.result === 'ok') {
            this.setState({ correctionDone: true });
        }

    }

    showTimer(timer) {
        document.getElementById('timer').innerHTML = timer;
    }

    render() {

        return(
            <div className='dashboard-container' style={{ marginBottom: 200 }}>
                <Prompt
                    when={this.state.doingTest}
                    message={t('sicuro_uscire')}
                />
                <h3 id="timer" style={{ position: 'fixed', top: 35, left: 0, width: '100vw', textAlign: 'center', color: 'red', fontWeight: 'bold', zIndex: 1000000000 }}>{this.state.timer}</h3>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 30 }}>
                    <section style={{ width: '100%' }}>
                        <h1>{cookies.get('currentDescrizione')}</h1>
                        <p>{t('while_info')}</p>
                    </section>
                </div>
                { this.state.domande.map((d, ind) => {

                    if (d.tipo === '0') return <VeroFalso key={d.id} ref={this.state.refs[ind]} domanda={d.domanda} allegato={d.allegato} />;
                    if (d.tipo === '1') return <SceltaMultipla key={d.id} ref={this.state.refs[ind]} domanda={d.domanda} risposte={JSON.parse(d.risposte)} />;
                    if (d.tipo === '2') return <TestoTesto key={d.id} ref={this.state.refs[ind]} testi={JSON.parse(d.domanda)} risposte={JSON.parse(d.risposte)} />;
                    if (d.tipo === '3') return <TestoImmagine key={d.id} ref={this.state.refs[ind]} testi={JSON.parse(d.domanda)} risposte={JSON.parse(d.risposte)} />;
                    if (d.tipo === '4') return <AudioVeroFalso key={d.id} ref={this.state.refs[ind]} domanda={d.domanda} audio={d.audio} />;
                    if (d.tipo === '5') return <AudioSceltaMultipla key={d.id} ref={this.state.refs[ind]} domanda={d.domanda} audio={d.audio} risposte={JSON.parse(d.risposte)} />
                    if (d.tipo === '6') return <Cloze key={d.id} ref={this.state.refs[ind]} testo={d.domanda} parole={JSON.parse(d.risposte)} />;
                    if (d.tipo === '7') return <RiorganizzazioneConcettuale key={d.id} ref={this.state.refs[ind]} testo={d.domanda} risposte={JSON.parse(d.risposte)} />;
                    if (d.tipo === '8') return <Completamento key={d.id} ref={this.state.refs[ind]} domanda={d.domanda} risposte={JSON.parse(d.risposte)} />;
                })}

                <div style={{ marginTop: 40, width: 200, marginLeft: 'calc((100% - 200px)/2)' }}>
                    <button style={{ marginTop: 30, backgroundColor: '#1877F2', color: 'white', padding: 10, border: 0, width: '100%', borderRadius: '5px', cursor:'pointer' }} onClick={() => {
                        if (window.confirm("Sei davvero sicuro/a di voler consegnare questo test?")) {
                            this.setState({doingTest: false});
                            this.endTest();
                        }
                    }}
                    >{t('consegna')}</button>
                </div>

                { this.state.inConsegna && (
                    <ConsegnaTest result={this.state.correctionDone} idTest={this.state.id} />
                )}
            </div>
        );
    }
}